// Module
var code = `
<template>
    <div class="comp-navigation \${isHorizontal ? 'horizontal' : ''}">

        <div class="nav-container">
            
            <div class="indicator" css="top: \${(50 * selectedNavItem.index)}px;" if.bind="!showOnlyExternal"></div>
            
            <template repeat.for="item of internallNavItems">
                <div class="nav-item \${item == selectedNavItem ? 'selected': ''}" click.trigger="onNavClick(item)" if.bind="!showOnlyExternal">
                    <comp-icon class="icon" icon="nav-\${item.value}"></comp-icon>
                </div>
            </template>
            
            <div class="divider" if.bind="!showOnlyExternal"></div>
            <div class="tools">
                <comp-icon class="icon-rotate" icon="arrow-rotate" width="20" height="20" click.trigger="rotateNav()" if.bind="false"></comp-icon>
                <comp-icon class="icon-grab" icon="grab" width="6" height="6" mousedown.trigger="onMousedown(\$event)"></comp-icon>
            </div>
            
            <template repeat.for="item of externalNavItems">
                <div class="nav-item" click.trigger="onNavClick(item)">
                    <comp-icon class="icon" icon="contact-\${item.value}"></comp-icon>
                </div>
            </template>
        </div>
    </div>
</template>`;
// Exports
export default code;